/**
 * Discovery-aligned Luminate track/agg filter toggles.
 * Checked = filter ON (matches discovery defaults).
 */
import DiscoveryFilterToolbar from './DiscoveryFilterToolbar'

export const DEFAULT_LUMINATE_DISCOVERY_FILTERS = {
  applyPLineIgnore: true,
  applyAudioMin: true,
  applyWeeksMin: true,
  applyTwRtdMax: true,
  applyPctChgMin: true,
  applyFocusGenres: true,
  applyResidualMin: true,
}

const FILTER_ITEMS = [
  {
    key: 'applyPLineIgnore',
    label: 'Unsigned Tags',
    title:
      'On: discovery set (hide p-line ignore + signed/junk). Off: show only p-line ignore OR signed/junk.',
  },
  { key: 'applyAudioMin', label: 'Audio % TW ≥ 30%' },
  { key: 'applyWeeksMin', label: 'Weeks ≥ 2' },
  { key: 'applyTwRtdMax', label: 'TW/RTD ≤ 95%' },
  {
    key: 'applyPctChgMin',
    label: '% Chg ≥ −10%',
    title: 'Keep blank % Chg when LW missing; drop only known % Chg below −10%',
  },
  {
    key: 'applyFocusGenres',
    label: 'Focus Genres',
    title:
      'Luminate Genres starts with Afrobeats, Alternative, Country, Folk, Indie Rock, Latin, Pop, Punk, R&B, Rap, or Rock',
  },
  { key: 'applyResidualMin', label: 'Residual ≥ 0' },
]

export default function LuminateDiscoveryFilters({
  filters,
  onChange,
  hideNonEnglish,
  onHideNonEnglishChange,
}) {
  return (
    <DiscoveryFilterToolbar
      filters={filters}
      onChange={onChange}
      defaultFilters={DEFAULT_LUMINATE_DISCOVERY_FILTERS}
      items={FILTER_ITEMS}
      hideNonEnglish={hideNonEnglish}
      onHideNonEnglishChange={onHideNonEnglishChange}
      hideNonEnglishTitle="Hide rows whose title/artist contains non-English characters"
    />
  )
}
